import {
  Component,
  OnInit,
  OnDestroy,
  OnChanges,
  Input,
  HostListener,
  SimpleChanges
} from '@angular/core'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'
import { File } from 'app/models/file'
import { FileStatus } from 'app/models/file-status.enum'
import { FileType } from 'app/models/file-type.enum'
import { FilesService } from 'app/services/files.service'
import { Source } from 'app/models/source.enum'

@Component({
  selector: 'app-viewer-content',
  templateUrl: './viewer-content.component.html',
  styleUrls: ['./viewer-content.component.scss']
})
export class ViewerContentComponent implements OnInit, OnDestroy, OnChanges {

  @Input() file: File
  @Input() hide: boolean
  @Input() isAdmin: boolean

  status: string
  hoverState: string
  source: string
  fileType = FileType
  pdfSource: SafeResourceUrl
  pdfError: boolean = false

  constructor(private fileService: FilesService, private sanitizer: DomSanitizer) {
  }

  @HostListener('mouseenter')
  onMouseEnter() {
    this.hoverState = 'hoverOn'
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    this.hoverState = 'hoverOut'
  }

  ngOnDestroy(): void {
    this.status = FileStatus.Hide
  }

  ngOnInit() {
    this.status = FileStatus.Active
    this.hoverState = ''
    this.getFile()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.file && (!changes.file.previousValue ||
      changes.file.currentValue.id !== changes.file.previousValue.id)) {
      this.pdfSource = null
      this.source = null
      this.pdfError = false
      this.getFile()
    }
  }

  getFile() {
    if (this.file.contentType === FileType.Img || this.file.contentType === FileType.Doc || (this.file.contentType === FileType.Video && !this.file.fileUrl)) {
      this.getSharepointFile()
    }
  }

  getSharepointFile() {
    const id = this.file.source === Source.Document ? this.file.id : this.file.documentId
    if (id) {
      this.fileService
        .download(id)
        .subscribe(
          (result) => {
            if (this.file.contentType === FileType.Img) {
              this.source = URL.createObjectURL(result.content)
            } else if (this.file.contentType === FileType.Video) {
              const blobUrl = URL.createObjectURL(result.content)
              this.file = Object.assign({}, this.file, { fileUrl: blobUrl }) as File
            } else {
              const blobUrl = URL.createObjectURL(result.content)
              this.pdfSource = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl)
            }
          },
          (error) => {
            console.error('Failed to download file:', id, error)
            this.pdfError = true
          }
        )
    }
  }
}
